import * as React from 'react';
import { useState, useEffect } from 'react';

export default function ({ accent, onSelect }: {
    accent: string,
    onSelect: (accent: string) => void,
}) {
    return (
    <select value={accent} onChange={e => onSelect(e.target.value)}>
        {(() => {
            return ['通行腔', '南部腔']
            .map(accent => <option>{accent}</option>);
        })()}
    </select>);
}
